import { Box, type SxProps } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  children?: JSX.Element | JSX.Element[];
  sx?: SxProps;
  enableDarkTheme?: boolean;
}

export const Base = ({ children, sx, enableDarkTheme = false }: Props) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Box
      sx={{
        boxShadow: '0px 0px 3px #00000029',
        height: 'auto',
        borderRadius: '5px',
        marginTop: '17px',
        backgroundColor: enableDarkTheme
          ? palette.boxBackground
          : palette.boxBackground,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
